import * as Common from '@/tenantCatalog/common';

export class PartnerPayment extends Common.StateObject{
  constructor(){
    super('PartnerPayment');
    this.state = PartnerPaymentStatus.pending;
    this.workflowStateId = PartnerPaymentStatus.pending;    
    this.binders.tenant = new Common.ModelBinder(Common.Tenant);
  }
  public tenantId :string = '';
  public tenant : Common.Tenant;
  public dueDate : Date;
  public partnerBookDate : Date;
  public billingAmount : number;
  public suspendAmount : number;  
  public taxAmount : number;
  public paymentAmount: number;
}
export enum PartnerPaymentStatus {
  pending = 1, 
  completed = 2,
  all = pending | completed,
}

export class PartnerPaymentQuery extends Common.LoadQuery {
  constructor(){
    super('PartnerPaymentQuery',PartnerPayment);
    this.sort = 'tenantId';    
  }
  public tenantId :string = '';
  public tenantName: string = '';
  public dueDate : Date = null;  
  public state : PartnerPaymentStatus = PartnerPaymentStatus.pending;  
}

//全銀ファイル出力用のクエリ
export class PartnerPaymentFileExportQuery extends Common.Query {
  constructor(sheetName:string, partnerPayments : Common.PartnerPayment[]){
    super("PartnerPaymentFileExportQuery",null);
    this.className = "PartnerPaymentFileExportQuery";
    this.sheetName = sheetName;
    this.partnerPayments = partnerPayments;
  }
  public sheetName  :string;  
  public partnerPayments : Common.PartnerPayment[] = null;

}

export class PartnerPaymentProcessQuery extends Common.Query {
  constructor(tenants: Common.Tenant[]){
    super('PartnerPaymentProcessQuery',null);
    this.tenants = tenants;
  }  
  public dueDate: Date = null;
  public tenants: Common.Tenant[] = null;
  public isAsync:boolean = true;
}